import React, { useEffect, useMemo, useState } from "react";
import { ChatCommonPage } from "../../../commonPage";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor, actionPatient } from "../../../redux/actions";
import { PiDotsThreeOutlineVertical } from "react-icons/pi";
import { Badges, DropDown } from "../../../components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const OngoingChats = ({ loginData }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            actionPatient.postGetChatAppointmentByPatient({
                RequestTimeZone: loginData.timeZoneId,
                currency: 'EUR',
                languageId: loginData?.languageId,
                patientGuid: loginData?.userGuid,
            })
        );
    }, [dispatch, loginData?.languageId, loginData.timeZoneId, loginData?.userGuid]);
    const postGetChatAppointmentByPatientData = useSelector(
        (state) => state.patient.postGetChatAppointmentByPatientData?.data
    );

    const filteredChats = useMemo(() =>
        postGetChatAppointmentByPatientData?.result?.filter((item) => item.status === 2) || [],
        [postGetChatAppointmentByPatientData]
    );

    const onSearchClick = () => {


    }

    const handleSelect = (id, appointment) => {

        if (id === "finalize-diagnostic") {

            navigate(
                `/doctor/diagnostic-report/diagnostic-report`,
                {
                    state: {
                        appointment,
                        appointmentStatus: 2,
                        onGoingChat: 2
                    },
                }
            )
        } else if (id === "respond") {
            navigate(
                `/patient/chat-with-doctor/${appointment?.appointmentGuid}`,
                { state: { appointment } }
            )
        }
    };

    return (
        <ChatCommonPage
            pageHeading={t("chatPage.onGoing.pageHeading")}
            loginData={loginData}
            chatTableHeading={t("chatPage.onGoing.chatTableHeading")}
            chatTableColumns={[`${t("booking_id")}`, `${t("doctor_name")}`, `${t("medical_specialty")}`, `${t("time_&_date")}`, `${t("status")}`, 'EUR', '']}
            chatTableData={filteredChats?.map((chat, index) => ({
                [t("booking_id")]: chat.chatBookingId,
                [t("doctor_name")]: chat.doctorName,
                [t("medical_specialty")]: chat.medicalSpeciality,
                [t("time_&_date")]: (
                    <>
                        <div>
                            {new Date(
                                chat.appointmentDateTime
                            ).toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            })}
                        </div>
                        <div>
                            {new Date(chat.appointmentDateTime)
                                .toLocaleDateString("en-GB")
                                .replace(/\//g, " - ")}
                        </div>
                    </>
                ),
                [t("status")]: chat.status === 2 ? "Ongoing" : "",
                'EUR': chat.chatFees,
                "": (
                    <DropDown.DropDown
                        className="moreaction-dropdown"
                        drpDwnText={
                            <PiDotsThreeOutlineVertical className="moreAction" />
                        }
                        drpItems={[
                            {
                                id: "finalize-diagnostic",
                                label: t("finalize-diagnostic"),
                            },
                            {
                                id: "respond",
                                label: t("respond"),
                            },
                        ]}
                        onSelect={(id) => handleSelect(id, chat)}
                    />
                ),
            }))}
            className="doctor-chats-ongoing"
            onSearchClick={onSearchClick}
        />
    );
};

export default OngoingChats;
